<!--
 * @Description: 
 * @Version: 1.0
 * @Autor: yyq
 * @Date: 2023-03-21 10:40:08
 * @LastEditors: ltw 326000014@qq.com
 * @LastEditTime: 2024-09-27 15:35:25
-->
<template>
  <div class="home">
    <img alt="Vue logo" src="../assets/logo.png" />
    <!-- <nav>
      <div>标签 <input v-model="title" /></div>
      <div>租户 <input v-model="tenant" /></div>
      <div>令牌 <input v-model="token" /></div>
      <div>did <input v-model="did" /></div>
      <div>日期 <input v-model="date" /></div>
      <router-link
        :to="`/live?did=${did}&title=${title}&tenant=${tenant}&token=${token}`"
        >视频</router-link
      >
      |
      <router-link
        :to="`/record?did=${did}&title=${title}&date=${date}&tenant=${tenant}&token=${token}`"
      >
        回放 </router-link
      >|
      <router-link :to="`/floorCheck?did=${did}&title=${title}`"
        >楼层校准</router-link
      >
      <br />
      <br />

      <br />
      <div>webRTC</div>
      <div>peerid <input v-model="peerid" /></div>
      <br />
      <router-link
        :to="`webrtclive/?did=${did}&peerid=${peerid}&title=${title}&outtime=${outtime}`"
        >视频</router-link
      >
      |
      <router-link
        :to="`/webrtcrecord?did=${did}&peerid=${peerid}&title=${title}&outtime=${outtime}`"
      >
        回放
      </router-link>
    </nav> -->
  </div>
</template>

<script>
export default {
  name: "HomeView",
  data() {
    // return {
    //   token: "Bearer cb8e4239-42df-4f40-909d-96d53f35f692",
    //   title: "湖南控网物联A栋2单元车间测试",
    //   tenant: "platform",
    //   did: "YXAI000034AWVHXZ",
    //   peerid: "KWWL-00-D5YV-Q9A5-00000053", //"CMEC000147VYWBBW", //测试CMEC000082ZAXLZL： CMEC000110FGHBJE//CMEC000129XCZBAB//CMEC000086026Z22
    //   date: "2023-03-23",
    //   outtime:120
    // };
  },
  components: {},
  mounted() {
    // console.log("HomeView-mounted");
  },
};
</script>
<style scoped>
.home {
  text-align: center;
}
</style>
